import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./components')).AppealSourceSelect,
  'appealSourceSelect',
  {
    style: '=?css',
    allowClear: '=?',
    ngModel: '=',
    managerMode: '=',
    placeholder: '@?',
  },
);
